import { useState } from 'react';

const NodeSettingAccordion = ({ icon, iconClass = 'text-info', title, visible, children }) => {
    const [expanded, setExpanded] = useState(visible || false);
    return (
        <div className='panel__section'>
            <div className='d-flex align-items-center justify-content-between'>
                <div className='d-flex align-items-center'>
                    {icon && <i className={`bi ${icon} me-1 ${expanded ? iconClass : ''}`}></i>}
                    <h5
                        onClick={() => setExpanded(expanded ? false : true)}
                        className='fs-8 p-0 m-0 cursor-pointer'>
                        {title}
                    </h5>
                </div>
                <div>
                    <span className='cursor-pointer ms-1'>
                        <i className='bi bi-dash-circle-fill'></i>
                    </span>
                    <span
                        className='cursor-pointer ms-2'
                        onClick={() => setExpanded(expanded ? false : true)}>
                        <i className={`bi bi-chevron-${expanded ? 'up' : 'down'}`}></i>
                    </span>
                </div>
            </div>
            {expanded && <>{children}</>}
        </div>
    );
};
export default NodeSettingAccordion;
